import { FormInstance } from "antd";
import { MessageValidate } from "constants/common.constants";
import { KYCStatus } from "constants/onboarding.constants";
import { FormatDateType } from "shared/models";

//convert file to base64
export function getBase64(img: File, callback: (data: ArrayBuffer | string | null) => void) {
  const reader = new FileReader();
  reader.addEventListener("load", () => callback(reader.result));
  reader.readAsDataURL(img);
}

// export function formatCash(number: number) {
//   return number.toLocaleString("en-US", { style: "currency", currency: "USD", signDisplay: 'never',  }).slice(1);
// }

export function formatCash(number: number) {
  if (!Number(number)) return "0.00";
  var DecimalSeparator = Number("1.2").toLocaleString().substr(1, 1);
  var priceWithCommas = Number(number).toLocaleString();
  var arParts = String(priceWithCommas).split(DecimalSeparator);
  var intPart = arParts[0];
  var decPart = arParts.length > 1 ? arParts[1] : "";
  decPart = (decPart + "00").substr(0, 2);
  return intPart + DecimalSeparator + decPart;
}

export const trimInput = (form: FormInstance, e: React.FocusEvent<HTMLInputElement, Element>) => {
  const { id, value } = e.target;
  return form.setFieldsValue({ [id]: value.trim() });
};

export const convertToInputNumber = (
  form: FormInstance,
  e: React.FocusEvent<HTMLInputElement>
): void => {
  const { id, value } = e.target;
  const cleanedValue = value.replace(/\D/g, "");
  form.setFieldsValue({ [id]: cleanedValue });
};

export const isLowerCase = (str: string) => {
  return str !== str.toUpperCase();
};

export const isUppercase = (str: string) => {
  return str !== str.toLowerCase();
};

export const checkSpecialCharacter = (str: string) => {
  let format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;
  return format.test(str);
};

export const checkValidEmail = (str: string) => {
  return /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(str);
};

export const compareString = (str1: string, str2: string) => {
  return String(str1).toLowerCase().localeCompare(String(str2).toLowerCase());
};

export const convertTimestamp = (timestamp: number | string) => {
  const date = new Date(Number(timestamp) * 1000);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();

  const formattedDate = `${day}/${month}/${year}`;
  const formattedTime = `${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;

  return `${formattedDate} ${formattedTime}`;
};

// use for type yyyy-mm-dd
export const convertStringToTimestampNumber = (dateStr : string) => {
  const [y, m, d] = dateStr.split("-").map(Number);

  const timestamp = Date.UTC(y, m - 1, d);
  return Math.floor(timestamp / 1000);
}

export const padZero = (number: number): string => {
  if (number < 10) {
    return "0" + number;
  }
  return number.toString();
};

export const formatDateByTimestamp = (timestamp: number, format: FormatDateType) => {
  const dateObject = new Date(timestamp * 1000);
  let formattedDate = "";

  let day: number = dateObject.getUTCDate();
  let month: number = dateObject.getUTCMonth() + 1;
  let year: number = dateObject.getUTCFullYear();
  let hoursNum: number = dateObject.getUTCHours();
  let hours: string = dateObject.getUTCHours().toString();
  let minutes: string = dateObject.getUTCMinutes().toString();
  let seconds: string =  dateObject.getUTCSeconds().toString();

  let formatDay = padZero(day);
  let formatMonth = padZero(month);
  let formatHours = padZero(Number(hours));
  let formatMinutes = padZero(Number(minutes));
  let formatSeconds = padZero(Number(seconds));

  let shortMonth = dateObject.toLocaleString("en-US", { month: "short", timeZone: "UTC" });

  const ampm = hoursNum >= 12 ? 'PM' : 'AM';
  const hours12 = hoursNum % 12 || 12;
  const formatHours12 = padZero(hours12);

  if (format === "DD/MM/YYYY") {
    formattedDate = formatDay + "/" + formatMonth + "/" + year;
  } else if (format === "MM/DD/YYYY") {
    formattedDate = formatMonth + "/" + formatDay + "/" + year;
  } else if (format === "YYYY/MM/DD") {
    formattedDate = year + "/" + formatMonth + "/" + formatDay;
  } else if (format === "DD/MM/YYYY HH:MM") {
    formattedDate =
      formatDay + "/" + formatMonth + "/" + year + " " + formatHours + ":" + formatMinutes;
  } else if (format === "MM/DD/YYYY HH:MM") {
    formattedDate =
      formatMonth + "/" + formatDay + "/" + year + " " + formatHours + ":" + formatMinutes;
  } else if (format === "YYYY/MM/DD HH:MM") {
    formattedDate =
      year + "/" + formatMonth + "/" + formatDay + " " + formatHours + ":" + formatMinutes;
  } else if (format === "MMM DD, YYYY") {
    formattedDate = shortMonth + " " + formatDay + ", " + year;
  } else if (format === "MMM DD, YYYY HH:MM:SS") {
    formattedDate =
    shortMonth + " " + formatDay + ", " + year + " " + formatHours + ":" + formatMinutes + ":" + formatSeconds;
  } else if (format === "MMM DD, YYYY · HH:MM AM/PM") {
    formattedDate =
      shortMonth + " " + formatDay + ", " + year + " · " + formatHours12 + ":" + formatMinutes + " " + ampm;
  }
  
  return formattedDate;
};

export const formatNumber = (num: number) => {
  if (num < 10) {
    return "0" + num;
  }
  return num;
};

export const checkNumberGreaterThan0 = (_: any, value: number) => {
  if (value === undefined || value === null) {
    return Promise.reject(new Error(MessageValidate.requiredField));
  }
  if (value >= 0) {
    return Promise.resolve();
  }
  return Promise.reject(new Error(MessageValidate.numberGreaterThan0));
};

export const checkNumberGreaterThanZero = (_: any, value: number) => {
  if (value === undefined || value === null) {
    return Promise.reject(new Error(MessageValidate.requiredField));
  }
  if (value > 0) {
    return Promise.resolve();
  }
  return Promise.reject(new Error(MessageValidate.numberGreaterThanZero));
};

export const validateDuplicatedFieldEmail = (flag = false) => {
  return async (_: any, value: string) => {
    if(flag){
      if (value === undefined || value === null || value.trim() === "") {
        return Promise.reject(new Error(MessageValidate.requiredField));
      }
    } else{
      if (value === undefined || value === null){
        value = "";
      }
    } 
    const valueConvert = value.replace(/\s+/g, '').toLowerCase();
    const emails = valueConvert.split(',');
    const validatedEmail = emails.some((element, index) => emails.indexOf(element) !== index);
    if(validatedEmail){
      return Promise.reject(new Error("Duplicated email found."));
    }
    return Promise.resolve();
  }
}

export const validateEmptyString = (_: any, value: string) => {
  if (value === undefined || value === null || value.trim() === "") {
    return Promise.reject(new Error(MessageValidate.requiredField));
  }
  return Promise.resolve();
}

export const validateOnlyDuplicatedLowerCaseFieldEmail = (_: any, value: string) => {
  if (value !== undefined && value !== null) {
    const valueConvert = value.replace(/\s+/g, '').toLowerCase().trim();
    const emails = valueConvert.split(',');
    const validatedEmail = emails.some((element, index) => emails.indexOf(element) !== index);
    if(validatedEmail){
      return Promise.reject(new Error("Duplicated email found."));
    }
  }
  return Promise.resolve();
} 

export const toastSuccess = {
  icon: `<img src={assetsIcons.checkIcon} alt="" />`,
  closeIcon: `<img src={assetsIcons.closeIcon} alt="" />`,
  message: "Success",
  duration: 100000000,
  description:
    "User created successfully User created successfully User created successfully User created successfully!",
};

export const convertStatusKYC = (status: string) => {
  switch (status) {
      case KYCStatus.Requested:
          return "Activation Request Received";
      case KYCStatus.CustomerVerification:
          return "Customer Verification Info Received";
      case KYCStatus.Live:
          return "Live";
  }
};

export const getFormattedDateTime = () => {
  const now = new Date();

  const year = now.getUTCFullYear();
  const month = String(now.getUTCMonth() + 1).padStart(2, '0'); // getUTCMonth() is zero-based
  const day = String(now.getUTCDate()).padStart(2, '0');
  const hours = String(now.getUTCHours()).padStart(2, '0');
  const minutes = String(now.getUTCMinutes()).padStart(2, '0');
  const seconds = String(now.getUTCSeconds()).padStart(2, '0');

  return `${year}${month}${day}${hours}${minutes}${seconds}`;
};

export const convertCountryCode = (countryData: any, countryCode: string) => {
  if (countryData) {
    const countryFound = countryData?.find((country: any) => country?.code === countryCode);
    if (countryFound) {
      return countryFound?.name;
    }
  }
  return countryCode
}

/** Parses the filename from a Content-Disposition header value (supports the RFC 5987 filename* form); returns "" when absent so callers can fall back to a FE-built name. */
export const getFileNameFromContentDisposition = (disposition?: string | null): string => {
  if (!disposition) return "";
  const utfMatch = disposition.match(/filename\*=(?:UTF-8'')?([^;]+)/i);
  if (utfMatch?.[1]) {
    return decodeURIComponent(utfMatch[1].trim().replace(/^"|"$/g, ""));
  }
  const match = disposition.match(/filename="?([^";]+)"?/i);
  return match?.[1]?.trim() ?? "";
};

/** Extracts the download filename (last path segment, query/hash stripped) from a URL such as an S3 path; returns "" when it has no file extension so callers can fall back to a FE-built name. */
export const getFileNameFromUrl = (url?: string): string => {
  if (!url) return "";
  try {
    const path = url.split("?")[0].split("#")[0];
    const base = decodeURIComponent(path.substring(path.lastIndexOf("/") + 1));
    // Only treat it as a filename when it carries an extension, so opaque keys (e.g. UUIDs) fall back to the FE-built name.
    return /\.[a-z0-9]{2,5}$/i.test(base) ? base : "";
  } catch {
    return "";
  }
};

